<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>

    <div class="main">
      <div class="page-content">

        <div class="achievement-wrap" v-for="(item,index) in achieveList" :key="index">
          <div class="ac-title">
            <h3>{{ item.name }}</h3>
            <span class="share" @click="shareFun(item.camp_id,index)"></span>
          </div>
          <div class="ac-list clearfix">
            <div class="item " 
              :class="{'active':items.is_buy === 1,'on':Number(shareSelectArr[index]) === Number(items.id) }" 
              :data-id="items.id"
              :data-index="shareSelectArr[index]"              
              v-for="(items,indexs) in item.hreo" 
              :key="indexs"
              @click="achieveShareSelectFun(item.camp_id,items.id,items.is_buy)"
            >
              <div class="img"><img :src="item.imageurl" alt="" /></div>
            </div>            
          </div>
          <div class="ac-info">
            <div class="title">成就奖励：</div>
            <div class="info">
              <div class="text">{{item.gift}}</div>
              <div class="btn" @click="receiveAchieveFun(item.camp_id,index)" v-if="item.is_user === 0">领取奖励</div>
              <div class="btn noClick" v-else>已领取</div>
            </div>
          </div>

        </div>

        <van-popup 
          class="shareFix"
          :closeable="true"
          v-model="shareIsShow"
          close-icon-position="top-right2">
          <div class="share-img"><img :src="shareImg" alt=""></div>
        </van-popup>

      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Toast,Dialog,Popup  } from "vant";
Vue.use(Dialog);
Vue.use(Popup);


export default {
  name: "achievement",
  data() {
    return {

      goodsWrap: 2,
      goodImg: require("../../../assets/images/home/goods/pic.png"),
      shareIsShow:false,
      shareImg:"",
      shareSelectArr:[],
      
    };
  },
  components: {
    SubHeader,
    [Dialog.Component.name]: Dialog.Component,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;

    let that = this;

    // that.toastLoading = Toast.loading({
    //   duration: 0, // 持续展示 toast
    //   forbidClick: true,
    //   message: "正在加载...",
    // });
    that.getAchieve();

  },
  methods: {
    ...mapActions({
      getAchieveList:"user/getAchieveList",
      setReceiveAchieve:"user/setReceiveAchieve",

    }),

    getAchieve(){
      let that = this;
      that.getAchieveList({
        success: (res) => {
          console.log(that.achieveList);          
          let shareSelectArr = [];
          for(let i in that.achieveList){
            shareSelectArr.push(-1);
          }
          that.shareSelectArr = shareSelectArr;

        }
      })
    },

    receiveAchieveFun(camp_id,index){
      console.log(camp_id,index);
      let that = this;
      let achieveList = that.achieveList[index];
      let achieveArrays = achieveList.hreo.filter((item)=>{
        return item.is_buy == 1
      })
      if(achieveList.hreo.length !== achieveArrays.length){
        Toast('您没有领取资格');
        return false;
      }
      if(achieveList.is_user === 1){
        Toast('不能重复领取');
        return false;
      }

      
      Dialog.alert({
        title: "领取奖励",
        allowHtml:true,
        closeOnClickOverlay:true,
        message: "<div style='line-height:1.6'>"+achieveList.giftdetail+"</div>",
        className: "dialog-public footer-center",
      }).then(() => {
        
        that.setReceiveAchieve({
          camp_id,
          success:(res)=>{
            console.log(res)
            if(res.status === 1){
              Toast('领取成功');
              that.getAchieve();
            } else {
              Toast(res.message);
            }
          }
        })


      });



    },

    // TODO
    achieveShareSelectFun  (camp_id,id,is_buy){
      let that = this;      
      if(Number(is_buy) !== 1){
        Toast('您还获得该成就');
        return false;
      }
      let newArr = [];
      for(let i in that.shareSelectArr){
        if(Number(camp_id) === Number(that.achieveList[i].camp_id)){
          if(Number(that.shareSelectArr[i]) === Number(id)){
            newArr[i] = -1;
          } else {
            newArr[i] = Number(id);
          }
        } else {
          newArr[i] = -1;
        }
      }
      that.shareSelectArr = newArr;
    },


    shareFun(camp_id,index){
      let that = this;
      let achieveList = that.achieveList;
      let achieveListFilters = {};

      let shareImg = "";

      for(let i in achieveList){
        if(achieveList[i].camp_id === camp_id){
          achieveListFilters = achieveList[i];
          break;
        }
      }
      let achieveArrays = achieveListFilters.hreo.filter((item)=>{
        return item.is_buy == 1
      })


      if(achieveArrays.length === 0){
        Toast('当前不可分享'); return false;
      }
      
      console.log(achieveListFilters);

      if(achieveListFilters.hreo.length !== achieveArrays.length){
        
        if(that.shareSelectArr[index] === -1){
          Toast('请选择您要分享的成就');
          return false;

        } else {
          shareImg = achieveListFilters.hreo[index].imageurl;
        }

      } else {

        console.log(that.shareSelectArr[index]);


        if(that.shareSelectArr[index] === -1){
          shareImg = achieveListFilters.imageurl;
        } else {
          shareImg = achieveListFilters.hreo[index].imageurl;
        }

      }

      
      that.shareImg = shareImg;
      that.shareIsShow = true;


    },
    


  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      achieveList:(state)=>state.user.achieveList,

    })
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.achievement-wrap {
  padding: 0 0.3rem;
  margin-bottom: 0.5rem;
  &:last-child {
    .ac-info {
      border: 0;
      padding-bottom: 0;
    }
  }

  .ac-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 0.5rem 0 0.15rem;
    h3 {
      font-size: 0.26rem;
      color: #fff0c4;
      font-weight: normal;
      text-shadow: -1px 0px 1px #221a14, 1px 0px 1px #221a14,
        0px -1px 1px #221a14, 0px 1px 1px #221a14;
    }
    .share {
      display: block;
      width: 0.4rem;
      height: 0.344rem;
      background: url(../../../assets/images/common/ic-share.png) no-repeat
        center;
      background-size: 100% auto;
    }
  }
  .ac-list {
    margin-top: 0.4rem;
    padding: 0 0.2rem 0.0865rem 0.35rem;
    .item {
      width: 1.86rem;
      height: 1.86rem;
      padding: 0.105rem;
      box-sizing: border-box;
      float: left;
      border-radius: 0.09rem;
      background-color: rgba(187, 178, 160, 0.341);
      box-shadow: 0.726px 2.911px 1px 0px rgba(0, 0, 0, 0.55);
      padding: 0.105rem;
      box-sizing: border-box;
      margin-right: 0.385rem;
      margin-bottom: 0.385rem;

      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);

      &.active {
        -webkit-filter: grayscale(0);
        -moz-filter: grayscale(0);
        -ms-filter: grayscale(0);
        -o-filter: grayscale(0);
      }

      &.on {
        background: url("~@/assets/images/user/set/img-border.png") no-repeat center;
        background-size: 100%;
      }


      &:nth-child(3n) {
        margin-right: 0;
      }
      .img {
        width: 1.65rem;
        height: 1.65rem;
        background: #000;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .ac-info {
    padding: 0 0.3rem 0.6rem 0.44rem;
    overflow: hidden;
    border-bottom: 0.02rem solid #d7d7d7;
    .title {
      color: #a4541f;
      font-size: 0.26rem;
    }
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.08rem;
      .text {
        flex: 1;
        font-size: 0.24rem;
        color: #784523;
        text-align: center;
        box-sizing: border-box;
        padding: 0 0.1rem;
      }
      .btn {
        font-size: 0.26rem;
        color: #593116;
        width: 1.83rem;
        height: 0.53rem;
        background: url(../../../assets/images/user/achievement/btn.png)
          no-repeat center;
        background-size: 100% auto;
        text-align: center;
        line-height: 0.51rem;

        &.noClick {
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
        }
      }
    }
  }
}


</style>

<style lang="scss">
  
.shareFix {   
  background:none;
  overflow-y: initial; 
  
  .share-img {
    img {
      max-width: 80vw;
    }
  }
  .van-popup__close-icon--top-right2 {
    right: -20px;
    top: -20px;
  }
}

</style>

